<template>
    <div class="xieyi_fenlei">
        <div class="xieyi_neirong">
            <p class="biaoti-xieyi">《酷皮音乐 VIP 服务条款》</p>
            <div class="wenzi_zhenduo">
一、服务说明

<br/>酷皮音乐提供的 VIP 服务旨在为用户带来更优质、更丰富的音乐体验，包括但不限于以下特权
<br/>1.无广告收听：在使用酷皮音乐服务时，将不再受到广告的干扰，享受流畅的音乐播放体验。
<br/>2.高品质音乐：可收听和下载高品质音乐文件，包括无损音质等，具体音质取决于您的设备和网络条件。
<br/>3.优先体验：优先获得新音乐上线、新功能推出以及各种活动的体验资格。
<br/>4.专属歌单：可以创建并保存更多的专属歌单，满足您的个性化音乐收藏需求。
<br/>5.离线收听：可在移动设备上下载更多的歌曲，以便在无网络的情况下离线收听。

<br/><br/>二、服务开通

<br/>1.用户可以通过酷皮音乐平台提供的支付方式开通 VIP 服务，包括但不限于支付宝、微信支付、银行卡支付等。
<br/>2.开通 VIP 服务时，您需要按照平台提示完成支付流程，支付相应的费用。一旦支付成功，即视为您已购买该服务，我们将为您开通 VIP 服务。
<br/>3.请确保您在支付时使用的支付账户信息真实、准确、有效，因支付账户信息错误导致的支付失败或其他问题，酷皮音乐不承担责任。

<br/><br/>三、服务期限

<br/>1.VIP 服务的期限根据您购买的套餐而定，可能包括但不限于月度 VIP、季度 VIP、年度 VIP 等。服务期限自您成功开通 VIP 服务的那一刻起开始计算，并在相应时长后结束。
<br/>2.在服务期限内，您可以享受上述的 VIP 特权。当服务期限届满时，若您未进行续费操作，您将自动恢复为普通用户，不再享有 VIP 特权。

<br/><br/>四、服务使用规则

<br/>1.您仅可在您本人的设备上使用 VIP 服务，且不得将您的 VIP 账户出租、出借、转让给他人使用，也不得通过任何方式共享您的 VIP 特权。
<br/>2.酷皮音乐有权对您使用 VIP 服务的设备数量进行限制，具体数量限制将根据不同的 VIP 套餐和平台政策而定。若发现您在超出限制的设备上使用 VIP 服务，我们有权暂停或终止您的 VIP 服务，且不退还已支付的费用。
<br/>3.您使用 VIP 服务应遵守当地的法律法规和道德规范，不得利用 VIP 服务从事任何违法、违规或不道德的行为，如使用 VIP 服务传播不良信息、侵犯他人知识产权等。

<br/><br/>五、费用及续费

<br/>1.不同 VIP 套餐的价格将在酷皮音乐的服务页面上明确显示，酷皮音乐有权根据运营成本、市场需求等因素对价格进行调整，但会提前通知用户。
<br/>2.对于自动续费服务：
<br/>1.若您选择了自动续费服务，您的支付账户将在您的 VIP 服务即将到期时自动扣除相应的费用以延续服务，具体的续费周期与您最初选择的套餐一致。
<br/>2.您可以随时在您的账户设置中关闭自动续费功能，但请确保在自动续费操作发生前完成操作，否则可能导致下一个周期的费用扣除。
<br/>3.如因您的支付账户余额不足或其他原因导致自动续费失败，酷皮音乐不承担责任，您的 VIP 服务将在服务期满后自动终止。

<br/><br/>六、服务暂停与终止

<br/>1.酷皮音乐可能会因以下原因暂停或终止您的 VIP 服务：
<br/>1.您违反本 VIP 服务条款的规定。
<br/>2.因不可抗力因素，如自然灾害、法律政策调整、网络故障等，导致无法继续提供服务。
<br/>3.酷皮音乐进行系统维护、升级或其他必要的运营调整。
<br/>4.您的行为对酷皮音乐的正常运营或其他用户造成损害或不良影响。
<br/>2.若因酷皮音乐的原因导致您的 VIP 服务被暂停或终止，我们将根据您剩余的服务期限和实际情况，采取相应的补偿措施，如退还部分费用、延长服务期限等；若因您的违规行为导致服务终止，我们将不退还已支付的费用。

<br/><br/>七、退款政策

<br/>1.一般情况下，一旦您成功开通 VIP 服务，不接受退款。但在以下特殊情况下，您可申请退款：
<br/>1.因酷皮音乐系统故障导致您无法正常使用 VIP 服务，且在合理时间内无法解决问题。
<br/>2.您在购买 VIP 服务时因平台显示错误、价格错误等原因导致支付了错误的金额。
<br/>3.您在购买 VIP 服务后，未使用任何 VIP 特权，且在购买后的规定时间内（例如 24 小时内）申请退款。
<br/>2.申请退款时，您需要向酷皮音乐客服提交申请，并提供相关证明，经酷皮音乐审核确认后，将为您办理退款手续。

<br/><br/>八、服务变更与更新

<br/>1.酷皮音乐保留对 VIP 服务的内容、功能、价格、服务条款等进行变更和更新的权利，我们将通过平台公告、短信、邮件等方式通知您。
<br/>2.您继续使用 VIP 服务即视为您接受这些变更和更新。若您不同意变更或更新，可以在服务期限届满后不再续费，或在变更生效前取消服务。

<br/>九、知识产权

<br/>1.酷皮音乐拥有 VIP 服务及其相关功能、界面、内容等的知识产权，包括但不限于软件著作权、商标权、专利权等。未经酷皮音乐的书面许可，您不得对其进行复制、修改、传播或用于其他商业目的。
<br/>2.对于 VIP 服务中所涉及的音乐作品，其版权归相应的音乐版权所有者所有，您仅可在本服务条款允许的范围内使用，不得侵犯音乐版权所有者的权利。

<br/><br/>十、隐私保护

<br/>1.酷皮音乐将按照我们的隐私政策保护您在使用 VIP 服务过程中的个人信息，包括但不限于您的支付信息、使用记录、设备信息等。
<br/>2.请您在使用 VIP 服务前仔细阅读我们的隐私政策，确保您了解并同意我们的信息处理方式。

<br/>十一、法律适用和争议解决

<br/>1.本 VIP 服务条款受 [具体国家或地区] 法律的管辖。
<br/>2.因本 VIP 服务条款的解释、履行或与本服务相关的任何争议，应首先通过友好协商解决；协商不成的，双方同意将争议提交至 [具体的仲裁机构或法院] 进行仲裁或诉讼。

<br/><br/>十二、其他条款

<br/>1.本 VIP 服务条款构成您与酷皮音乐之间关于 VIP 服务的完整协议，取代之前的所有口头或书面协议。
<br/>2.如本条款的部分内容被认定为无效或无法执行，不影响其他部分的效力。


            </div>
        </div>
    </div>
</template>
<script>
// 服务协议
export default {

}
</script>
<style lang="scss" scoped>
.xieyi_fenlei {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .xieyi_neirong {
        width: 1200px;
        // background-color: antiquewhite;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;

        .biaoti-xieyi {
            font-size: 23px;
            font-family: YuanTi;
            font-weight: bold;
            margin-bottom: 20px;
            color: var(--them-color);
        }

        .wenzi_zhenduo {
            font-size: 16px;
            font-family: YuanTi;
            color: var(--xieyi-size);
            line-height: 33px;
            padding-bottom: 20px;
            white-space: pre-wrap;
            word-wrap: break-word;
            word-break: break-all;
        }
    }
}
</style>